<script lang="ts" setup>
import ProductTab from '~/enums/product-tab'
import type { ProductTabData } from '~/types/products'

const model = defineModel<ProductTab>()

const props = defineProps<{
  totalAttributes: number
  totalPublishedReviews: number
}>()

const productTabsData = computed(() => {
  const { Attributes, Description, Questions, Reviews } = ProductTab
  const { totalAttributes, totalPublishedReviews } = props

  return [
    { count: null, isEnabled: true, productTab: Description },
    { count: null, isEnabled: totalAttributes > 0, productTab: Attributes },
    { count: totalPublishedReviews, isEnabled: true, productTab: Reviews },
    { count: null, isEnabled: true, productTab: Questions }
  ].filter((x: ProductTabData): boolean => x.isEnabled)
})

</script>

<template>
  <section>
    <div class="container">
      <div class="-m-1 flex flex-wrap">
        <div
          v-for="x in productTabsData"
          :key="x.productTab"
          class="
            m-1 box-border flex !w-auto cursor-pointer items-center justify-center rounded-xl border border-solid
            border-white bg-white px-4 py-[10px] font-bold hover:text-main-green
          "
          :class="{ '!border-main-green text-main-green': model === x.productTab }"
          @click="model = x.productTab"
        >
          {{ ProductTab.getName(x.productTab) }}

          <div
            v-if="x.count !== null"
            class="ml-2 inline-block rounded-lg bg-main-aluminum px-2 py-1 text-[0.75em] leading-[1em] text-white"
          >
            {{ x.count }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
